import { Component, OnInit } from "@angular/core";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "app1";

  ngOnInit() {
    this.loadNewrelicScript();
  }

  public loadNewrelicScript() {
    /* Create your script */
    const head = <HTMLDivElement>document.head;
    const script = document.createElement("script");

    if (environment.env == "prod") {
      script.src = "./assets/scripts/newrelic/prod.js";
    } else if (environment.env == "qa") {
      script.src = "./assets/scripts/newrelic/qa.js";
    } else {
      script.src = "./assets/scripts/newrelic/staging.js";
    }
    /* add your script to DOM */
    head.appendChild(script);
  }
}

const API_VERSION_V1 = "v1";
const API_VERSION_V2 = "v2";
const API_VERSION_V3 = "v3";
/**
 * Global variable declaration for api route
 */
export const GlobalVariable = Object.freeze({
  BASE_API_URL: environment.apiHost,

  /** Public logo url */
  PUBLIC_LOGO_URL: API_VERSION_V1 + "/business/public-logo/",

  /** appointment urls */
  GET_APPOINTMENT_METADATA: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/appointment-slug`,
  GET_TAG_TEAM_MEMBERS: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/tag-team-member/list`,
  GET_BOOKING_SLOTS: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/booking-slots`,
  BOOK_APPOINTMENT_V3: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/consumer-booking`,
  GET_BOOKING_DETAILS: (slug, booking_id) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/appointment/${booking_id}`,
  BOOK_INQUIRY: (slug) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/enquiry/create`,
  GET_INQUIRY_DETAILS: (slug, inquiry_id) =>
    API_VERSION_V3 + `/appointment-consumer/${slug}/enquiry/${inquiry_id}`,

  // Customer Appointment Booking
  // APPOINTMENT_SETTINGS: API_VERSION_V2 + '/appointment/settings',
  APPOINTMENT_SLUG: API_VERSION_V2 + "/appointment/appointment-slug", // This is the old appointment flow we are keeping this just as backup
  TEAM_MEMBERS: API_VERSION_V2 + "/appointment/tag-member/list",

  AVAILABLE_SLOTS: API_VERSION_V2 + "/appointment/available-booking-slots",
  BOOK_APPOINTMENT: API_VERSION_V2 + "/appointment/consumer-booking",
  WHATSAPP_VERIFY: API_VERSION_V2 + "/interaction-management/verify-whatsapp",

  // detele appointment
  GET_DELETE_APPOINTMENT_SLUG:
    API_VERSION_V3 + "/appointment-consumer/appointment",
  DELETE_APPOINTMENT: API_VERSION_V3 + "/appointment-consumer/delete",

});
